import { createContext, useContext } from 'react';
import { SelectProps } from '@cloudscape-design/components';
import { InstanceData } from '@@/types/InstanceData';

export interface AuthContextType {
  currentInstance: string | undefined;
  setCurrentInstance: (instanceId: string) => void;
  instanceData: InstanceData | undefined;
  loading: boolean;
  error: Error | null;
  getDropdownInstanceOptions: () => SelectProps.Options;
  getTableInstanceData: () => InstanceData[];
  refetch: () => Promise<unknown>;
  getPathWithInstanceAlias: (path: string) => string;
  user: {
    id: string;
    email: string;
  };
}

export const AuthContext = createContext<AuthContextType>({} as AuthContextType);

// Separate context type for GlobalAuthProvider
export interface GlobalAuthContextType extends AuthContextType {
  globalPermissions: string[];
}

export const GlobalAuthContext = createContext<GlobalAuthContextType | null>(null);

// Custom hook for accessing GlobalAuthContext
export const useGlobalAuth = () => {
  const context = useContext(GlobalAuthContext);
  if (!context) {
    throw new Error('useGlobalAuth must be used within a GlobalAuthProvider');
  }
  return context;
};
